import { useEffect, useState } from "react";
import Logo from "../components/Logo";
import LoadingButton from "../components/LoadingButton";
import { useDispatch } from "react-redux";
import { signinRequest } from "../redux/action/signinAction";
import { useNavigate } from "react-router-dom";
import Utils from "../utility/utility";
import { STRING } from "../constants/string";

const FieldError = ({ msg }) => (
  <span className={"field-error" + (msg ? " is-shown" : "")}>{msg || ""}</span>
);

const Login = () => {
  const [emaildata, setEmaildata] = useState("");
  const [passworddata, setPassworddata] = useState("");
  const [showpassword, setshowpassword] = useState(false);
  const [errors, setErrors] = useState({ email: "", password: "" });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  /* The button owns the request now, so the form only has to stop the native
     navigation. Pressing Enter in a field still works: implicit submission
     dispatches a click at the default submit button, which is the one below. */
  const formSubmit = (e) => {
    e.preventDefault();
  };

  /* Resolves when the saga reports the session, rejects when it reports a
     failure - the saga already toasted it by then, so nothing is said twice. */
  const signIn = () => {
    if (!validateLoginFields()) return false;

    const payload = {
      username: emaildata,
      password: passworddata,
      showSuccessToast: true,
    };

    return new Promise((resolve, reject) => {
      dispatch(
        signinRequest(
          payload,
          (response) => {
            resolve(response);
            navigate("/home");
          },
          reject
        )
      );
    });
  };

  /* Validates both fields at once and returns the message map, so the form
     can show every problem inline rather than only the first one as a toast. */
  const validateLoginFields = () => {
    const next = { email: "", password: "" };

    if (Utils.isEmpty(emaildata)) {
      next.email = STRING.ENTER_EMAIL;
    } else if (!Utils.validateEmail(emaildata)) {
      next.email = STRING.ENTER_VALID_EMAIL;
    }

    if (Utils.isEmpty(passworddata)) {
      next.password = STRING.ENTER_PASSWORD;
    } else if (passworddata.length < 6) {
      next.password = STRING.ENTER_SIX_DIGIT_PASSWORD;
    }

    setErrors(next);
    return !next.email && !next.password;
  };

  return (
    <>
      <div className="">
        <div className="login-bg">
          <div className="card w-login">
            <div className="col-md-12 card-body">
              <div className="text-center">
                <Logo className="rapid-logo" />
              </div>
              <div className="text-center mt-5">
                <h3 className="text-rapid">Hi, Welcome Back</h3>
              </div>
              <div className="text-center mt-3">
                <p className="text-bold">Sign in with Email address</p>
              </div>
              <form autoComplete="off" onSubmit={formSubmit}>
                <div className="col-md-12">
                  <div
                    className={
                      "login-field" + (errors.email ? " is-invalid" : "")
                    }
                  >
                    <label htmlFor="loginEmail">Email Address / Username</label>
                    <input
                      id="loginEmail"
                      type="text"
                      autoComplete="username"
                      value={emaildata}
                      onChange={(event) => {
                        setEmaildata(event.target.value);
                        if (errors.email) {
                          setErrors((prev) => ({ ...prev, email: "" }));
                        }
                      }}
                    />
                  </div>
                  <FieldError msg={errors.email} />

                  <div
                    className={
                      "login-field" + (errors.password ? " is-invalid" : "")
                    }
                  >
                    <label htmlFor="loginPassword">Password</label>
                    <div className="login-field-control">
                      <input
                        id="loginPassword"
                        type={showpassword === true ? "text" : "password"}
                        autoComplete="current-password"
                        value={passworddata}
                        onChange={(event) => {
                          setPassworddata(event.target.value);
                          if (errors.password) {
                            setErrors((prev) => ({ ...prev, password: "" }));
                          }
                        }}
                      />
                      <button
                        type="button"
                        className="login-reveal"
                        onClick={() => {
                          setshowpassword((wasOpened) => !wasOpened);
                        }}
                        aria-label={
                          showpassword ? "Hide password" : "Show password"
                        }
                      >
                        <i
                          className={
                            showpassword ? "fa fa-eye" : "fa fa-eye-slash"
                          }
                          aria-hidden="true"
                        ></i>
                      </button>
                    </div>
                  </div>
                  <FieldError msg={errors.password} />

                  <div className="top-check">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value="1"
                        id="keep_me_signIn"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="keep_me_signIn"
                      >
                        Keep me signin
                      </label>
                    </div>
                  </div>
                  <div className="text-cnter mt-4 mb-3">
                    <LoadingButton
                      type="submit"
                      className="sign-in-btn w-100"
                      pendingLabel="Signing in"
                      successLabel="Signed in"
                      onAction={signIn}
                    >
                      Sign In
                    </LoadingButton>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
